<!-- Modal Update Account Info -->

<form #addAccForm="ngForm" novalidate (ngSubmit)="updateAccFormSubmit(addAccForm)">
  <div class="modal-body pt-1">
    <!-- <div class="row">
            <div class="col">
              <div class="form-group mb-1">
                <label><span class="maroon  astrisk">&#10033;&nbsp;</span>Account
                  Type</label>
                <select id="model" class="w-100" aria-placeholder="Select Type" [(ngModel)]="updateAccModal.type"
                  name="type" (change)="typeSelected($event)" #type="ngModel">
                  <option class="w-break" *ngFor="let type of accTypes" value={{type.type}}>
                    {{type.type | customText}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col pl-0">
              <div class="form-group mb-1">
                <label><span class="maroon  astrisk">&#10033;&nbsp;</span>Account Sub
                  Type</label>
                <select id="model" class="w-100" aria-placeholder="Select Sub Type" [(ngModel)]="updateAccModal.category"
                  name="subType" (change)="subTypeSelected($event)" #subType="ngModel">
                  <option class="w-break" *ngFor="let subType of currentSubType" value={{subType}}>
                    {{subType | customText}}
                  </option>
                </select>
              </div>
            </div>
          </div> -->

    <div class="row mt-1">
      <div class="col-lg-2 col-md-2 col-sm-3 col-3 pr-0 text-center">
        <div *ngIf="!updateAccModal.logo">
          <img src="assets/images/placeholder.png" class="img-thumbnail full-img">
        </div>
        <div *ngIf="updateAccModal.logo">
          <img [src]="updateAccModal.logo" class="img-thumbnail full-img">
        </div>
        <div style="height:0px;overflow:hidden">
          <input #uploadAccountLogo id="uploadLogoInput" name="uploadLogoInput" type="file"
            (click)="uploadAccountLogo.value=null" (change)="uploadFleetLogo($event)" accept=".jpg,.png,.jpeg">
        </div>
        <small><a style="cursor:pointer" (click)="changeuploadFleetLogoClicked()"><u>Upload Logo</u></a></small>
      </div>
      <div class="col-lg-10 col-md-10 col-sm-9 col-9">
        <div class="form-group mb-1">
          <label><span class="maroon  astrisk">&#10033;&nbsp;</span>Fleet Account
            Name</label>
          <input type="text" class="form-control" [(ngModel)]="updateAccModal.name" name="accountName"
            #accountName="ngModel" readonly required>
          <small class="text-danger text-center" *ngIf="accountName.errors && addAccForm.submitted">
            <p class="mb-0" *ngIf="accountName.errors.required">*Required</p>
          </small>
        </div>

        <div class="form-group mb-1">
          <label><span class="maroon  astrisk">&#10033;&nbsp;</span>Street
            Address</label>
          <input type="text" class="form-control" [(ngModel)]="updateAccModal.contactPoints.addresses[0].street"
            name="address" #address="ngModel" required>
          <small class="text-danger text-center" *ngIf="address.errors && addAccForm.submitted">
            <p class="mb-0" *ngIf="address.errors.required">*Required</p>
          </small>
        </div>
        <div class="row">
          <!-- <div class="col">
            <div class="form-group mb-1">
              <label><span class="maroon astrisk">&#10033;&nbsp;</span>Country</label>
              <select id="countrySelect" class="w-100" aria-placeholder="Select Country"
                [(ngModel)]="updateAccModal.contactPoints.addresses[0].country"
                (change)="onCountrySelected($event.target.value)" name="country" #country="ngModel" required>
                <option [ngValue]=null>Select Country</option>
                <option *ngFor="let country of countryList" value={{country.name}}>{{country.name}}</option>
              </select>
              <small class="text-danger text-center" *ngIf="country.errors && addAccForm.submitted">
                <p class="mb-0" *ngIf="country.errors.required">*Required</p>
              </small>
            </div>
          </div> -->
          <div class="col">
            <div class="form-group mb-1">
              <label><span class="maroon  astrisk">&#10033;&nbsp;</span>ZipCode</label>
              <input type="text" class="form-control" [(ngModel)]="updateAccModal.contactPoints.addresses[0].postalCode"
                name="postalCode" #postalCode="ngModel" pattern="[0-9]{5}" maxlength="5"
                (input)="getZipCodeDetails($event.target.value)"
                oninput="this.value = this.value.replace(/[^0-9]/g, '');" required>
              <small class="text-danger text-center" *ngIf="postalCode.errors && addAccForm.submitted">
                <p class="mb-0" *ngIf="postalCode.errors.required">*Required</p>
                <p class="mb-0" *ngIf="!postalCode.errors.required && !invalidZipCode">Invalid Zip-Code</p>
              </small>
              <small class="text-danger text-center" *ngIf="invalidZipCode">
                <p class="mb-0">Invalid Zip-Code</p>
              </small>
            </div>
          </div>
          <div class="col">
            <div class="form-group mb-1">
              <label>Plus4 Code</label>
              <input type="text" class="form-control" [(ngModel)]="updateAccModal.contactPoints.addresses[0].plus4Code"
                name="plus4Code" #plus4Code="ngModel" pattern="[0-9]{4}" maxlength="4" minlength="4"
                oninput="this.value = this.value.replace(/[^0-9]/g, '');">
              <small class="text-danger text-center" *ngIf="plus4Code.errors && addAccForm.submitted">
                <p class="mb-0" *ngIf="plus4Code.errors?.pattern">Invalid Plus4 Code</p>
              </small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group  mb-1">
              <label><span class="maroon  astrisk">&#10033;&nbsp;</span>City</label>
              <input type="text" class="form-control" [(ngModel)]="updateAccModal.contactPoints.addresses[0].city"
                name="city" #city="ngModel" required>
              <small class="text-danger text-center" *ngIf="city.errors && addAccForm.submitted">
                <p class="mb-0" *ngIf="city.errors.required">*Required</p>
              </small>
            </div>
          </div>
          <div class="col">
            <div class="form-group mb-1">
              <label><span class="maroon astrisk">&#10033;&nbsp;</span>State</label>
              <select id="model" class="w-100" aria-placeholder="Select State"
                [(ngModel)]="updateAccModal.contactPoints.addresses[0].state" name="state"
                (change)="stateSelected($event)" #state="ngModel" required>
                <option [ngValue]="null">Select State</option>
                <option *ngFor="let state of stateList" value={{state}}>{{state}}</option>
              </select>
              <!-- <input type="text" class="form-control" [(ngModel)]="updateAccModal.contactPoints.addresses[0].state"
                          pattern="[A-Za-z]{2}" maxlength="2" name="state" #state="ngModel" required> -->
              <small class="text-danger text-center" *ngIf="state.errors && addAccForm.submitted">
                <p class="mb-0" *ngIf="state.errors.required">*Required</p>
              </small>
            </div>
          </div>
        </div>
        <!-- <div class="form-group mb-1">
                <label><span class="maroon  astrisk">&#10033;&nbsp;</span>Fleet Customer
                  Id</label>
                <input type="text" class="form-control" [(ngModel)]="updateAccModal.oemCustomerId" name="oemCustomerId"
                  #oemCustomerId="ngModel" required>
                <small class="text-danger text-center" *ngIf="oemCustomerId.errors && addAccForm.submitted">
                  <p class="mb-0" *ngIf="oemCustomerId.errors.required">*Required</p>
                </small>
              </div> -->

        <label class="heading mt-3 mb-2">Contact Info :</label>

        <div class="form-group mb-1">
          <label>Email Address</label>
          <input type="email" class="form-control" [(ngModel)]="updateAccModal.contactPoints.emails[0].value"
            name="addAccountEmail" #addAccountEmail="ngModel" pattern="^[^@]+@[^@]+\.[^@]+$" email>
          <small class="text-danger text-center" *ngIf="addAccountEmail.errors && addAccForm.submitted">
            <p class="mb-0" *ngIf="!addAccountEmail.errors.required">Invalid email</p>
          </small>
        </div>

        <div class="form-group mb-1">
          <label>Phone Number</label>
          <div class="row">
            <div class="form-group col-4 pr-1">
              <ng-template #rt_isd let-r="result" let-t="term">
                <ngb-highlight [result]="r.name + ' ' + r.isd" [term]="t"></ngb-highlight>
              </ng-template>
              <input id="typeahead-isd-template" type="text" class="form-control" name="isd" #isd="ngModel"
                placeholder="ISD..." [(ngModel)]="selectedIsdDetails" [ngbTypeahead]="searchIsd"
                [resultTemplate]="rt_isd" [inputFormatter]="isdFormatter" [editable]='false'
                (selectItem)="onIsdSelected($event.item)" required disabled>
              <small class="text-danger text-center" *ngIf="isd.errors && addAccForm.submitted">
                <p class="mb-0" *ngIf="isd.errors.required">*Required</p>
              </small>
            </div>
            <div class="col-8 pl-1">
              <input type="text" class="form-control" [(ngModel)]="updateAccModal.contactPoints.phones[0].value"
                name="addAccountPhone" #addAccountPhone="ngModel" [pattern]="'[0-9]{' + phoneLength + '}'"
                [placeholder]="'X'.repeat(phoneLength)" [maxlength]="phoneLength"
                oninput="this.value = this.value.replace(/[^0-9]/g, '');">
            </div>
          </div>
          <small class="text-danger text-center" *ngIf="addAccountPhone.errors && addAccForm.submitted">
            <p class="mb-0" *ngIf="!addAccountPhone.errors.required">Invalid phone</p>
          </small>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light btn-80" (click)="resetUpdateAccForm()">CANCEL</button>
    <button type="submit" class="btn btn-primary border btn-80">Save</button>
  </div>
</form>